module.exports = __webpack_public_path__ + "img/pleisure_bodyimage04.dd853292.jpg";